module.exports = __webpack_public_path__ + "static/media/IMG-10.19c9235d.jpg";